import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from '@repo/app-router';
import { SidebarGroup, SidebarGroupContent, SidebarGroupLabel, SidebarMenu, SidebarMenuItem } from '@repo/ui-primitives/sidebar';
import { Skeleton } from '@repo/ui-primitives/skeleton';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { useEffect, useRef } from 'react';
import { useSideBarProjectList } from 'ze-sdk';
import { ProjectItem } from './project-item';
export function ProjectsList(param) {
    let { organization, expandedProjects, onToggleProject, onExpandProject, onExpandAll, onCollapseAll } = param;
    var _ref;
    const params = useParams({
        from: '/org/$organization/$project',
        shouldThrow: false
    });
    const paramProject = (params === null || params === void 0 ? void 0 : params.project) || '';
    const { data: projectListResponse, isLoading: projectsLoading } = useSideBarProjectList({
        organization
    });
    const projectList = (_ref = projectListResponse === null || projectListResponse === void 0 ? void 0 : projectListResponse.entities) !== null && _ref !== void 0 ? _ref : [];
    const hasAutoExpandedRef = useRef(false);
    useEffect(()=>{
        if (paramProject && projectList && onExpandProject && !hasAutoExpandedRef.current) {
            const currentProject = projectList.find((p)=>p.name === paramProject);
            if (currentProject && !expandedProjects.has(currentProject.id)) {
                onExpandProject(currentProject.id);
                hasAutoExpandedRef.current = true;
            }
        }
    }, [
        paramProject,
        projectList,
        onExpandProject,
        expandedProjects
    ]);
    if (projectsLoading) {
        return /*#__PURE__*/ _jsxs(SidebarGroup, {
            children: [
                /*#__PURE__*/ _jsx(SidebarGroupLabel, {
                    className: "text-xs font-medium text-muted-foreground/70 uppercase tracking-wider",
                    children: "Loading..."
                }),
                /*#__PURE__*/ _jsx(SidebarGroupContent, {
                    children: /*#__PURE__*/ _jsxs(SidebarMenu, {
                        children: [
                            /*#__PURE__*/ _jsx(SidebarMenuItem, {
                                children: /*#__PURE__*/ _jsx(Skeleton, {
                                    className: "h-6 w-full"
                                })
                            }),
                            /*#__PURE__*/ _jsx(SidebarMenuItem, {
                                children: /*#__PURE__*/ _jsx(Skeleton, {
                                    className: "h-6 w-full"
                                })
                            }),
                            /*#__PURE__*/ _jsx(SidebarMenuItem, {
                                children: /*#__PURE__*/ _jsx(Skeleton, {
                                    className: "h-6 w-full"
                                })
                            })
                        ]
                    })
                })
            ]
        });
    }
    if (!projectList || projectList.length === 0) {
        return /*#__PURE__*/ _jsxs(SidebarGroup, {
            children: [
                /*#__PURE__*/ _jsx(SidebarGroupLabel, {
                    className: "text-xs font-medium text-muted-foreground/70 uppercase tracking-wider",
                    children: "Projects"
                }),
                /*#__PURE__*/ _jsx(SidebarGroupContent, {
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "text-sm text-muted-foreground p-2",
                        children: "No projects found"
                    })
                })
            ]
        });
    }
    const allProjectsExpanded = projectList.every((project)=>expandedProjects.has(project.id));
    const someProjectsExpanded = expandedProjects.size > 0;
    const handleToggleAll = ()=>{
        if (allProjectsExpanded || someProjectsExpanded) {
            onCollapseAll === null || onCollapseAll === void 0 ? void 0 : onCollapseAll();
        } else {
            const allProjectIds = projectList.map((project)=>project.id);
            onExpandAll === null || onExpandAll === void 0 ? void 0 : onExpandAll(allProjectIds);
        }
    };
    return /*#__PURE__*/ _jsxs(SidebarGroup, {
        children: [
            /*#__PURE__*/ _jsxs(SidebarGroupLabel, {
                className: "text-xs font-medium text-muted-foreground/70 uppercase tracking-wider flex items-center justify-between group",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        children: "Projects"
                    }),
                    projectList.length > 0 && /*#__PURE__*/ _jsx("button", {
                        onClick: handleToggleAll,
                        className: "opacity-0 group-hover:opacity-100 transition-opacity p-0.5 hover:bg-sidebar-accent rounded-sm",
                        title: allProjectsExpanded ? 'Collapse all projects' : 'Expand all projects',
                        children: allProjectsExpanded ? /*#__PURE__*/ _jsx(ChevronDown, {
                            className: "h-3 w-3"
                        }) : /*#__PURE__*/ _jsx(ChevronRight, {
                            className: "h-3 w-3"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(SidebarGroupContent, {
                className: "text-gray-25",
                children: /*#__PURE__*/ _jsx(SidebarMenu, {
                    children: projectList.sort((a, b)=>a.name.localeCompare(b.name)).map((project)=>{
                        return /*#__PURE__*/ _jsx(ProjectItem, {
                            project: {
                                id: project.id,
                                name: project.name,
                                displayName: project.name,
                                counters: {
                                    applications: 0
                                }
                            },
                            organization: organization,
                            isExpanded: expandedProjects.has(project.id),
                            onToggle: ()=>{
                                onToggleProject(project.id);
                            }
                        }, project.id);
                    })
                })
            })
        ]
    });
}
